import { FunctionComponent, MouseEventHandler, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import {
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import CardTitle from 'containers/common/Card/CardTitle';
import styled from 'styled-components';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { translate } from 'containers/services/translate';
import { Config, Listings } from 'containers/AppContainer/typings';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { get } from 'lodash';
import { LISTINGS } from 'containers/data-structure';
import { injectIntl, IntlShape } from 'react-intl';

const DialogTitle = (props: any) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton}>
          <CloseIcon onClick={onClose} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    width: '100%',
    height: '100%',
  },
}))(MuiDialogContent);
const DialogTitleStyled = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))(DialogTitle);
const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    min-width: 900px;
  }
  .MuiFormControl-root {
    width: 800px;
  }
  .MuiDialogActions-root {
    flex: 0 0 auto;
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
  }
`;
const DialogDisclaimerWarranty: FunctionComponent<{
  intl: IntlShape;
  open: boolean;
  listings: Listings;
  handleClose: MouseEventHandler;
  title: string;
  confirmTitle: string;
  cancelTitle: string;
  handleValidate: any;
}> = (props): JSX.Element => {
  const [warrantyReasonId, setWarrantyReasonId] = useState<number | null>(null);
  /* istanbul ignore next */
  const handleChangeExpertise = (event: React.ChangeEvent<{ value: any }>) =>
    setWarrantyReasonId(event.target.value);
  return (
    <div>
      <StyledDialog
        onClose={/* istanbul ignore next */ () => props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitleStyled onClose={props.handleClose}>
          <div className="header">
            <CardTitle count={-1} message={props.title} />
          </div>
        </DialogTitleStyled>
        <DialogContent dividers>
          <FormControl className="field">
            <InputLabel>
              {translate(messages.ExlusionOfWarrantyReasonTitle, props)}
            </InputLabel>
            <Select value={warrantyReasonId} onChange={handleChangeExpertise}>
              {get(
                props.listings,
                LISTINGS.DISCLAIMER_WARRANTY_REASONS,
                [],
              ).map((warrantyReason: Config) => (
                <MenuItem value={warrantyReason.id} key={warrantyReason.id}>
                  {warrantyReason.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            title={props.cancelTitle}
            onClick={props.handleClose}
          />
          <PrimaryButton
            background={'#0075C9'}
            titlecolor={'#FFFFFF'}
            border={'#0075C9'}
            title={props.confirmTitle}
            onClick={props.handleValidate(warrantyReasonId)}
            disabled={false}
          />
        </DialogActions>
      </StyledDialog>
    </div>
  );
};
export default injectIntl(DialogDisclaimerWarranty);
